import React from 'react';
import { useTranslation } from 'react-i18next';

import { Box, Typography } from '@mui/material';

import { StyledTooltip } from '../StyledTooltip/StyledTooltip';

import { QuestionIcon } from './QuestionIcon';

export const LeaderboardListHeader = () => {
  const { t } = useTranslation('components', { keyPrefix: 'leaderboard' });
  return (
    <Box
      display="grid"
      gridTemplateColumns="75% 25%"
      sx={{ borderBottom: '1px solid', borderColor: 'grey.300', color: 'grey.500', mb: 2 }}
    >
      <Typography variant="h4" ml={7} mb={3}>
        {t('header.name')}
      </Typography>
      <Box display="flex" alignItems="center" mb={3}>
        <Typography variant="h4" mr={2}>
          {t('header.score')}
        </Typography>
        <StyledTooltip
          placement="right"
          title={
            <Box p={4} width={146}>
              <Typography variant="text3" display="block" pb={4}>
                {t('tooltipTask.title')}
              </Typography>
              <Typography variant="text3" display="block">
                {t('tooltipTask.description1')}
              </Typography>
              <Typography variant="text3">{t('tooltipTask.description2')}</Typography>
            </Box>
          }
          sx={{ zIndex: 1, p: 0 }}
        >
          <Box sx={{ cursor: 'pointer' }}>
            <QuestionIcon />
          </Box>
        </StyledTooltip>
      </Box>
    </Box>
  );
};
